module.exports.GHUB_TYPE_ERROR_EXPECT_STRING = 'The function was expecting a string but did not get a string.';